import script from "./HomeworkDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeworkDashboard.vue?vue&type=script&setup=true&lang=js"

import "./HomeworkDashboard.vue?vue&type=style&index=0&id=cc6945c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc6945c0"]])

export default __exports__